<footer [ngClass]="{'menuHidden': hideMenu}" class="mb-0 footer">
    <div class="container-fluid fs-6 mb-0">
        <img alt="bottom-logo" class="bottom-logo" src="assets/images/alt-logo.png" />
        &nbsp;
        &#169; 2015-{{year}} by Evide.
        All Rights Reserved. Use of this website constitutes acceptance of the
        &nbsp;
        <a href="https://demo3.impact-tracker.net/site/Openpdf?fid=Evide+EULA+2018" target="_blank">
            End User License Agreement
        </a>
        &nbsp;and&nbsp;
        <a href="assets/docs/Evide%20Impact%20Ltd%20Privacy%20Policy%202026.pdf" target="_blank">
            Privacy Policy
        </a> .
    </div>
</footer>